import { buildUrl } from '@/helpers/buildUrl';

// https://api.dev.trueplay.io/api/v1/copystake/admin/swagger-ui/index.html
export const BASE = (): string => '/api/v1/copystake/control';

export const BASE_OPERATOR = (): string => buildUrl(`${BASE()}/{operatorId}`);
